import clsx from 'clsx';

import type { PendingCartProduct } from '@jane/shared/models';
import {
  Box,
  DismissIcon,
  Flex,
  Image,
  JaneGoldIcon,
  Tag,
  Typography,
} from '@jane/shared/reefer';
import type { PriceId } from '@jane/shared/types';
import { productPhotoMetadata } from '@jane/shared/util';

import styles from '../specialDetailStatus.module.css';

export interface ProductRowProps {
  isDiscounted: boolean;
  isGold: boolean;
  isUnlocked: boolean;
  onRemoveProduct: ({
    priceId,
    productId,
  }: {
    priceId: PriceId;
    productId: number;
  }) => void;
  product: PendingCartProduct;
  tagLabel: string;
}
export const ProductRow = ({
  isDiscounted,
  isGold,
  isUnlocked,
  onRemoveProduct,
  product,
  tagLabel,
}: ProductRowProps) => {
  const showTag = isDiscounted && tagLabel;

  const { url: photoUrl } = productPhotoMetadata(product);

  return (
    <Flex alignItems="center" data-testid="product-row">
      <Box position="relative">
        <Image
          src={photoUrl}
          height="48px"
          width="48px"
          altText={product.name}
          borderRadius="8px"
          className={styles.border__light__gray}
        />
        <Flex
          top={-8}
          right={-8}
          width={24}
          height={24}
          position="absolute"
          background="grays-white"
          border="grays-light"
          borderRadius="lg"
          alignItems="center"
          justifyContent="center"
        >
          <DismissIcon
            onClick={() =>
              onRemoveProduct({
                priceId: product.price_id,
                productId: product.id,
              })
            }
            altText={`Remove ${product.name}`}
            size="sm"
            className={styles.icon__xs}
          />
        </Flex>
      </Box>

      <Typography ml={16} truncateAt="100%">
        {product.name}
      </Typography>

      {showTag && (
        <Tag
          ml="auto"
          label={tagLabel}
          icon={isGold ? <JaneGoldIcon /> : undefined}
          color={isGold ? 'grays-black' : 'grays-white'}
          background={isGold ? 'gold' : 'info'}
          className={clsx(styles.white__space__no__wrap, {
            [styles.opacity__not__unlocked]: !isUnlocked,
          })}
          data-testid="product-tag"
        />
      )}
    </Flex>
  );
};
